<template>
    <v-container class="bg-red">
        
      <h1>JellyGo App Terms and Conditions</h1>
      These terms and conditions ("Terms") govern your use of the JellyGo mobile application (the "App"). By downloading, installing, or using the App, you agree to comply with and be bound by these Terms. If you do not agree with any part of these Terms, you must not use the App.
          <br><br><p class="subheader">1. License</p>
          <br>1.1. Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to use the App for your personal, non-commercial purposes.
          <br>
          <br>1.2. You may not:
          <br>(a) modify, adapt, translate, reverse engineer, decompile, disassemble or create derivative works based on the App;
          <br>(b) remove, alter or obscure any copyright, trademark or other proprietary rights notice on or in the App;
          <br>(c) use the App for any illegal or unauthorized purpose; or
          <br>(d) sublicense, sell, resell, transfer, assign, distribute or otherwise commercially exploit or make available to any third party the App or any of its features or content.
          <br>
          <br><p class="subheader">2. User Accounts</p>
          <br>2.1. In order to access certain features of the App, you may be required to create a user account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.
          <br>
          <br>2.2. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account or any other breach of security.
          <br>
          <br><p class="subheader">3. Privacy</p>
          <br>3.1. Your use of the App is subject to our Privacy Policy, which is incorporated into these Terms by reference. By using the App, you consent to the collection and use of your information as described in the Privacy Policy.
          <br>
          <br><p class="subheader">4. Intellectual Property</p>
          <br>4.1. The App and all content and materials contained therein, including without limitation, p, graphics, logos, images, audio clips, video clips, data compilations, and software, are the property of JellyGo or its licensors and are protected by copyright, trademark, and other intellectual property laws.
          <br>
          <br>4.2. You may not use, copy, reproduce, modify, adapt, translate, distribute, transmit, display, perform, or sublicense any of the content or materials contained in the App without our prior written consent.
          <br>
          <br><p class="subheader">5. Disclaimer of Warranties</p>
          <br>5.1. The App is provided on an "as is" and "as available" basis without warranties of any kind, either express or implied, including, but not limited to, warranties of merchantability, fitness for a particular purpose, or non-infringement.
          <br>
          <br>5.2. We do not warrant that the App will be uninterrupted or error-free, that defects will be corrected, or that the App or the servers that make it available are free of viruses or other harmful components.
          <br>
          <br><p class="subheader">6. Limitation of Liability</p>
          <br>6.1. To the fullest extent permitted by applicable law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from:
          <br>(a) your use or inability to use the App;
          <br>(b) any unauthorized access to or use of our servers or any personal information stored therein;
          <br>(c) any bugs, viruses, Trojan horses, or other harmful code that may be transmitted to or through the App by any third party; or
          <br>(d) any errors, inaccuracies, or omissions in any content or materials provided by or through the App.
          <br>
          <br>6.2. In no event shall our aggregate liability for all claims relating to the App exceed the total amount paid by you, if any, for accessing or using the App during the twelve (12) months prior to the date of the claim.
          <br>
          <br><p class="subheader">7. Indemnification</p>
          <br>7.1. You agree to indemnify, defend, and hold harmless JellyGo and its officers, directors, employees, agents, affiliates, licensors, and suppliers from and against any and all losses, liabilities, expenses, damages, and costs, including reasonable attorneys' fees, resulting from:
          <br>(a) your use or misuse of the App;
          <br>(b) your violation of these Terms or any applicable law or regulation; or
          <br>(c) your violation of any rights of any third party.
          <br>
          <br><p class="subheader">8. Modification of Terms</p>
          <br>8.1. We reserve the right to modify or update these Terms at any time by posting the revised Terms on the App. Your continued use of the App after any such changes constitutes your acceptance of the revised Terms.
          <br>
          <br><p class="subheader">9. Governing Law</p>
          <br>9.1. These Terms shall be governed by and construed in accordance with the laws of Malaysia, without regard to its conflict of law provisions.
          <br>
          <br><p class="subheader">10. Contact Us</p>
          <br>10.1. If you have any questions about these Terms, please contact us at jellygo2022@gmail.com.
    </v-container> 

  </template>
  
  <script>
  
  
  export default {
    name: 'TnC',
    components: {
    }
  }
  </script>
  
<style scoped>
p{
    font-size: larger;
    font-weight: bold;
}

</style>